export default "__VITE_ASSET__eb54fbcb__"